var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExitFullscreen = function SvgExitFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "transparent"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.178 23.332v-6.167a3 3 0 0 1 3-3h6.166M10.18 23.332v-6.167a3 3 0 0 0-3-3H1.013M10.166 1v6.167a3 3 0 0 1-3 3H.999M14.166 1v6.167a3 3 0 0 0 3 3h6.167",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgExitFullscreen;